/* ===========================================================================
   fg-reveal.js — one reveal module for the whole site

   ---------------------------------------------------------------------------
   THE BUG THIS FIXES (v11). The first version paired the observer with a blind
   `setTimeout(play, 2000)` per element, as a safety net against content being
   stranded invisible. It was blind to the viewport, so two seconds after page
   load EVERY card on the page played — including the ten below the fold. By
   the time you scrolled to them they had already finished, and the reveal you
   were meant to see had happened to an empty screen.

   The net was right; firing it unconditionally was wrong. A rescue must only
   rescue something that is ACTUALLY ON SCREEN and has not played.

   Three layers now, in order of preference:
     1. IntersectionObserver — the normal path.
     2. A one-shot viewport-checked sweep shortly after load, which catches an
        observer that silently never fires for something already in view.
     3. A shared passive scroll/resize listener, which covers the same failure
        for content further down the page. It detaches itself once everything
        has played, so it costs nothing on a healthy page.

   CSS half lives in assets/fg-system.css. Start frames are applied there under
   `html.fg-js`, set synchronously in the head, so this script never has to
   hide anything — it only ever plays. That is why there is no flash.
   =========================================================================== */
(function () {
  'use strict';

  var SELECTOR = '[data-fg-reveal]';
  var pending = [];          /* elements armed and not yet played */
  var listening = false;

  function play(el) {
    el.classList.add('fg-on');
  }

  /* Generous but honest: an element counts as seen once any part of it is
     inside the viewport. Matches the observer's 0.01 threshold. */
  function inView(el) {
    var r = el.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var vw = window.innerWidth || document.documentElement.clientWidth;
    return r.bottom > 0 && r.top < vh && r.right > 0 && r.left < vw;
  }

  function sweep() {
    for (var i = pending.length - 1; i >= 0; i--) {
      var el = pending[i];
      if (el.classList.contains('fg-on')) {
        pending.splice(i, 1);
        continue;
      }
      if (inView(el)) {
        play(el);
        pending.splice(i, 1);
      }
    }
    if (!pending.length && listening) {
      window.removeEventListener('scroll', sweep);
      window.removeEventListener('resize', sweep);
      listening = false;
    }
  }

  function listen() {
    if (listening) return;
    listening = true;
    window.addEventListener('scroll', sweep, { passive: true });
    window.addEventListener('resize', sweep, { passive: true });
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var nodes = scope.querySelectorAll(SELECTOR);

    Array.prototype.forEach.call(nodes, function (el) {
      if (el.getAttribute('data-fg-init') === '1') return;
      el.setAttribute('data-fg-init', '1');

      /* Focus must never land on something invisible. */
      el.addEventListener('focusin', function () { el.classList.add('fg-done'); });

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          for (var i = 0; i < entries.length; i++) {
            if (entries[i].isIntersecting) {
              play(el);
              io.disconnect();
              return;
            }
          }
        }, { threshold: 0.01 });
        io.observe(el);

        /* Layers 2 and 3 — viewport-checked, never blind. */
        pending.push(el);
      } else {
        /* No observer at all: fall back entirely to the scroll sweep. */
        pending.push(el);
        sweep();
      }
    });

    if (pending.length) {
      listen();
      /* One delayed sweep for anything on screen at load that the observer
         did not report. Short, because it only ever affects visible content. */
      window.setTimeout(sweep, 1200);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  /* Shopify's theme editor swaps section markup in without a page load. */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:select', function (e) { init(e.target); });

  /* Exposed so the head snippet can tell this module loaded, and so a section
     that injects its own markup can re-arm it. */
  window.fgReveal = init;
})();
